module.exports = __webpack_public_path__ + "icon_add_group.0e2cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_add_group.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_add_group.svg
// module chunks = main